
<template>
    
        <mars-view v-if="list && list.length" :id="'lawyer-recommend-' + position" class="lawyer-recommend-container" :data-serverid="serverId" data-area="lawyer-phonecall-recommend" :data-exts="JSON.stringify({
        position,
    })" :data-extswan="{
        position,
    }"><mars-view class="recommend-title" :class="'recommend-title-' + fontSizeSetting"><mars-view class="left">{{ primaryArea }}律临精选律师推荐</mars-view><mars-view class="right" @click.native="viewMore">
            更多律师<mars-view class="arrow"></mars-view></mars-view></mars-view><mars-view class="recommend-list"><mars-view v-for="lawyerInfo,index in list" :id="'lawyer-item-' + lawyerInfo.qc_core_no" :key="index" class="recommend-item" :data-serverid="serverId" data-area="lawyer-item-1v1" :data-exts="JSON.stringify({
                order: index,
                index,
                uk: lawyerInfo.uk,
                position,
            })" :data-extswan="{
                order: index,
                index,
                uk: lawyerInfo.uk,
                position,
            }" @click.native="jumpLawyerHome(index, lawyerInfo)"><mars-view class="lawyer-left"><mars-view class="lawyer-left-info"><mars-image class="lawyer-left-info-img" :lazy-load="true" :src="lawyerInfo.lawyer_avatar" mode="aspectFit"></mars-image><mars-view class="lawyer-tag"></mars-view></mars-view></mars-view><mars-view class="lawyer-mid"><mars-view class="lawyer-mid-name"><mars-view class="lawyer-mid-name-left">
                        {{ lawyerInfo.lawyer_name }}
                    </mars-view><mars-image v-if="lawyerInfo.members_icon" class="lawyer-mid-name-vip" :src="lawyerInfo.vip_type === 7 ?
                            'https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/young-vip-member.png' :
                            'https://lvlin-base.cdn.bcebos.com/law/pages/iknowqa/lawyer-vip.png'"></mars-image><mars-view v-if="lawyerInfo.lawyer_position" class="lawyer-mid-name-right">
                        {{ lawyerInfo.lawyer_position }}
                    </mars-view></mars-view><mars-view class="lawyer-mid-time-firm"><mars-view v-if="lawyerInfo.show_register_years && lawyerInfo.practice_year" class="lawyer-mid-time">
                        {{ lawyerInfo.practice_year }}
                    </mars-view><mars-view class="lawyer-mid-firm">
                        {{ lawyerInfo.practice_company }}
                    </mars-view></mars-view><mars-view v-if="lawyerInfo.primaryType" class="lawyer-major-area">
                    擅长: {{ lawyerInfo.primaryType }}
                </mars-view></mars-view><mars-view class="lawyer-right" @click.native.stop="clickPhone(index, lawyerInfo)">咨询我</mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import { act } from '../../../static/utils/navigate';
import log from '../../../static/utils/ubcLog';
import { inSightObserverDisconnects, inSightObservers } from '../../../common/js/repeatExposureLog.js';
import { consultPageChange } from '../../../static/utils/consultEvents.js';
export default {
  name: 'lawyerRecommendCard',
  props: {
    recommendVipLawyer: {
      type: Array,
      default() {
        return [];
      }
    },
    primaryArea: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'midCard'
    },
    from: {
      type: String,
      default: ''
    },
    serverId: {
      type: Number,
      default: 16908
    },
    frHead: {
      type: String,
      default: 'tuoguan'
    },
    hostedContentFrom: {
      type: String,
      default: ''
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      lawyerListTime: null
    };
  },
  watch: {
    recommendVipLawyer: {
      immediate: true,
      handler(newval) {
        newval.forEach(item => {
          item.primaryType = item.primary_type && item.primary_type.join(' ') || '';
          if (item.service_type === 'phone_free_target_pre') {
            item.phone = item.service_target && item.service_target.slice(2).split('').reverse().join('') || '';
          }
        });
        this.list = newval.slice(0, 3);
        if (newval.length && !this.lawyerListTime) {
          this.lawyerListTime = setTimeout(() => {
            newval.forEach(item => {
              inSightObservers(`#lawyer-item-${item.qc_core_no}`, '', {}, [], true, true, true);
            });
            inSightObservers(`#lawyer-recommend-${this.position}`, '', {}, [], true, true, true);
          }, 1000);
        }
      }
    }
  },
  methods: {
    viewMore() {
      log.send({
        serverId: this.serverId,
        action: 'click',
        area: 'more-lawyer-btn',
        position: this.position
      });
      act({
        target: `/pages/expertlist/index?vn=law&from=qb&expertiseArea=${this.primaryArea || ''}`,
        type: 'url'
      });
    },
    jumpLawyerHome(order, lawyerInfo) {
      const {
        lawyer_target = '',
        uk = ''
      } = lawyerInfo;
      const from = `${this.frHead}_${"h5"}_${this.from}${this.hostedContentFrom === 'pgc_lvlin_aigc' ? '_aigc' : ''}`;
      log.send({
        serverId: this.serverId,
        action: 'click',
        uk,
        area: 'lawyer-item-1v1',
        order,
        index: order,
        position: this.position,
        from
      });
      act({
        target: `${lawyer_target}&fr=${from}`,
        type: 'url'
      });
    },
    clickPhone(order, lawyerInfo) {
      const {
        service_type = '',
        uk = '',
        agent_id = ''
      } = lawyerInfo;
      const from = `${this.frHead}_${"h5"}_${this.from}`;
      log.send({
        serverId: this.serverId,
        action: 'click',
        area: 'phonecall-area',
        uk,
        agentID: agent_id,
        type: service_type,
        order,
        index: order,
        position: this.position,
        from,
        fr: `${from}_consult${this.hostedContentFrom === 'pgc_lvlin_aigc' ? '_aigc' : ''}`
      });
      const {
        qc_core_no
      } = lawyerInfo;
      let urlParams = {
        fr: `${from}${this.hostedContentFrom === 'pgc_lvlin_aigc' ? '_aigc' : ''}`
      };
      qc_core_no && consultPageChange(qc_core_no, urlParams);
    }
  },
  destroyed() {
    (function () {
      inSightObserverDisconnects();
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.lawyer-recommend-container {
  line-height: 1;
  font-family: PingFang SC;
  background: #fff;
  padding: 0.17rem;
  margin-top: 0.08rem;
}
.lawyer-recommend-container .recommend-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  font-size: 0.18rem;
  font-family: PingFang SC;
  color: #1e1f24;
  font-weight: 700;
}
.lawyer-recommend-container .recommend-title .right {
  font-family: PingFang SC;
  font-size: 0.15rem;
  color: #848691;
  text-align: right;
  line-height: 0.15rem;
  vertical-align: bottom;
  display: flex;
  align-items: center;
  font-weight: 400;
  margin-right: -0.03rem;
}
.lawyer-recommend-container .recommend-title .right .arrow {
  width: 0.14rem;
  height: 0.14rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/pages/iknowqa/right-arrow.png") no-repeat;
  background-size: 100% 100%;
  margin-left: 0.02rem;
  margin-top: -0.02rem;
}
.lawyer-recommend-container .recommend-title-5 .left {
  font-size: 15px;
}
.lawyer-recommend-container .recommend-title-5 .right {
  font-size: 10px;
}
.lawyer-recommend-container .recommend-item {
  margin-top: 0.327rem;
  display: flex;
  position: relative;
}
.lawyer-recommend-container .recommend-item .lawyer-left .lawyer-left-info {
  width: 0.52rem;
  height: 0.52rem;
  position: relative;
}
.lawyer-recommend-container .recommend-item .lawyer-left .lawyer-left-info .lawyer-left-info-img {
  background: #81848f;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.lawyer-recommend-container .recommend-item .lawyer-left .lawyer-left-info .lawer-left-info-rank {
  width: 0.18rem;
  height: 0.18rem;
  position: absolute;
  right: 0;
  bottom: 0;
}
.lawyer-recommend-container .recommend-item .lawyer-left .lawyer-left-info .lawyer-tag {
  width: 0.18rem;
  height: 0.18rem;
  position: absolute;
  border-radius: 50%;
  bottom: 0;
  right: 0;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/expertlist/icon-yellow-v.png') no-repeat center center / 100% 100%;
}
.lawyer-recommend-container .recommend-item .lawyer-mid {
  margin-left: 0.09rem;
  width: calc(100% - 144px);
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-name {
  display: flex;
  align-items: center;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-name .lawyer-mid-name-left {
  font-size: 0.17rem;
  color: #1e1f24;
  font-family: PingFang SC;
  font-weight: 700;
  white-space: nowrap;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-name .lawyer-mid-name-right {
  font-family: PingFang SC;
  font-size: 11px;
  line-height: 1;
  color: #05f;
  padding: 0.02rem 0.04rem 0.01rem;
  margin-left: 0.08rem;
  border: 0.8px solid rgba(0, 85, 255, 0.5);
  border-radius: 0.04rem;
  white-space: nowrap;
  font-weight: bold;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-name .lawyer-mid-name-vip {
  width: 0.49rem;
  min-width: 0.49rem;
  height: 0.18rem;
  margin-left: 0.06rem;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-time-firm {
  width: calc(100% - 10px);
  font-size: 0.14rem;
  color: #50525c;
  display: flex;
  margin-top: 0.07rem;
  white-space: nowrap;
  line-height: 1.1;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-time-firm .lawyer-mid-time {
  flex-shrink: 0;
  margin-right: 0.08rem;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-mid-time-firm .lawyer-mid-firm {
  overflow: hidden;
  text-overflow: ellipsis;
}
.lawyer-recommend-container .recommend-item .lawyer-mid .lawyer-major-area {
  color: #50525c;
  margin-top: 0.07rem;
  font-size: 0.14rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.15;
}
.lawyer-recommend-container .recommend-item .lawyer-right {
  width: 0.7rem;
  height: max-content;
  text-align: center;
  background: rgba(0, 85, 255, 0.1);
  border-radius: 0.16rem;
  font-size: 0.13rem;
  font-weight: 700;
  font-family: PingFang SC;
  color: #05f;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  line-height: 1;
  padding: 0.08rem 0;
}
.lawyer-recommend-container .recommend-item:first-child {
  margin-top: 0.27rem;
}

</style>
